import styled, { TColorProp } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { getThemeColor } from '~/common/utils/get-theme-color';
import { SPACING } from '~/common/layout-propertis/spacing';
import { RADIUS } from '~/common/layout-propertis/radius';

interface IAlertInfoContainerProps {
  readonly width: string;
  readonly color: TColorProp;
  readonly textAlign: string;
}
export const AlertInfoContainer = styled.div<IAlertInfoContainerProps>`
  width: ${({ width }) => width};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
  padding: ${SPACING._16};
  position: relative;
  border-top-right-radius: ${RADIUS._4};
  text-align: ${({ textAlign }) => textAlign};
  border-bottom-right-radius: ${RADIUS._4};
  background-color: ${({ color, theme }) =>
    hexToRgba(getThemeColor(theme, color), 0.25)};

  #border-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background-color: ${({ theme, color }) => getThemeColor(theme, color)};
  }
`;
